import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="razorpay"
export default class extends Controller {
  async checkout(event) {
    event.preventDefault();

    // 1. DEFINE THE BUTTON
    const btn = event.currentTarget;
    const selectedTier = event.params.tier;

    // Save original text and show loading state to prevent double-clicks
    const originalText = btn.innerText;
    btn.disabled = true;
    btn.innerText = "Loading...";

    try {
      // 2. Fetch the Subscription ID generated on your Rails backend
      const response = await fetch("/subscriptions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
          Accept: "application/json",
        },
        body: JSON.stringify({ tier: selectedTier }),
      });

      if (!response.ok) {
        throw new Error("Failed to create subscription on the server.");
      }

      const data = await response.json();

      // 3. CHECK FOR RAZORPAY SCRIPT
      if (typeof window.Razorpay === "undefined") {
        throw new Error(
          "Razorpay script failed to load. Please refresh the page.",
        );
      }

      // 4. Initialize the Razorpay Checkout Modal
      const options = {
        key: data.key, // Public API key passed from Rails backend
        subscription_id: data.sub_id, // The subscription entity ID generated by Razorpay
        name: "SaudaChat",
        description: `Upgrade to ${selectedTier.charAt(0).toUpperCase() + selectedTier.slice(1)} Tier`,
        theme: {
          color: selectedTier === "pro" ? "#0D2D2A" : "#0A7C6E",
        },

        // 🛑 THE FIX: Force Razorpay to render UPI AutoPay intent apps (GPay, PhonePe) inside the Android WebView.
        webview_intent: true,

        // Optional but highly recommended: Prefill helps skip the initial email/phone screen.
        // If you have access to the current user's data in the DOM, pass it here.
        prefill: {
          contact: data.phone_number || "",
          email: data.email || "",
        },

        // 5. THE SECURE HANDLER
        handler: async function (response) {
          try {
            // Log response properties to the browser console to watch properties stream live
            console.log("Razorpay Response Verification Object:", response);

            // Send payload directly to your collection route: /subscriptions/verify
            const verifyResponse = await fetch("/subscriptions/verify", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": document.querySelector(
                  'meta[name="csrf-token"]',
                ).content,
                Accept: "application/json",
              },
              body: JSON.stringify({
                razorpay_payment_id: response.razorpay_payment_id,
                // FALLBACK PATHWAY: If response.razorpay_subscription_id is missing inside the return token,
                // pass down the data.sub_id token generated during step 2 initialization.
                razorpay_subscription_id:
                  response.razorpay_subscription_id || data.sub_id,
                razorpay_signature: response.razorpay_signature,
                tier: selectedTier,
              }),
            });

            const verifyData = await verifyResponse.json();

            if (verifyResponse.ok && verifyData.success) {
              // Signatures match, local databases upgraded, proceed to success route safely
              window.location.href = "/subscriptions/success";
            } else {
              throw new Error(
                verifyData.error || "Backend verification failed.",
              );
            }
          } catch (err) {
            console.error("Verification Error:", err);
            alert(`Payment completed, but verification failed: ${err.message}`);
          }
        },
      };

      const rzp = new window.Razorpay(options);

      // Handle closed modal or failed payments
      rzp.on("payment.failed", function (response) {
        console.error("Payment failed", response.error);
        alert(`Payment Failed: ${response.error.description}`);
      });

      // Open the modal window
      rzp.open();
    } catch (error) {
      console.error("Checkout Error:", error);
      alert(error.message);
    } finally {
      // 6. Reset button states cleanly
      btn.disabled = false;
      btn.innerText = originalText;
    }
  }
}
